export class MicroFrontendService {
    static addSource(url) {
        return new Promise((resolve, reject) => {
            if (!url || MicroFrontendService.isScriptLoaded(url)) {
                return false;
            }
            const script = document.createElement('script');
            script.setAttribute('src', url);
            script.onload = () => resolve(script);
            script.onerror = reject;
            document.body.appendChild(script);
        });
    }
    static isScriptLoaded(url) {
        return document.querySelector('script[src="' + url + '"]');
    }
}
